<template>
  <custom-dialog width="600px" :append-to-body="true" :title="title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules" :validate-on-rule-change="false">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('er_name1_lxmc')" prop="mapName">
              <el-input v-model="form.mapName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button @click="closeDialog">{{ $t('com_cancel') }}</el-button>
      <el-button type="warning" @click="onConfirm">{{ $t('er_name1_que_ren') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

// er_name1_que_ren: 确认// er_name1_lxmc: 路线名称// er_name1_bjlxmc: 编辑路线名称（{0}）

export default {
  name: '',
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        mapName: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        mapName: {
          required: true,
          message: this.$t('com_required')
        },
      };
    },
    title() {
      if (this.model.data) {
        const row = this.model.data;
        const { hlcCode, siteName, slotCode } = row;
        const str = [hlcCode, siteName, slotCode].filter(val => !!val).join('/');
        return str ? this.$t('er_name1_bjlxmc', [str]) : '';
      }
      return '';
    },
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    async onConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const reqData = this.getReqData();
          await this.$postJSON(apis.hlcSlotEditMapName, reqData);
          this.$message({
            message: this.$t('com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
          this.closeDialog();
        }
      });
    },
    getReqData() {
      const ret = {
        hlcSlotId: this.model.data.hlcSlotId,
        mapName: this.form.mapName,
      };
      return ret;
    },
    init() {
      if (this.model.data && this.model.data.mapName) {
        const mapName = this.model.data.mapName;
        this.form.mapName = mapName;
      }
    },
  },
  mounted() {
    this.mergeLanguage(null, 'portal_edit_route_name_dialog');
    this.init();
  },
};
</script>

<style></style>
